'use client';

import { useConsent } from '@/lib/consent/consent-context';
import { Cookie } from 'lucide-react';

export function ConsentFooterLink() {
  const { reopen } = useConsent();

  return (
    <button onClick={reopen} className="text-base text-white">
      Cookie Settings
    </button>
  );
}
